import React, { useState } from 'react'
import logo from '../images/logo_wings.svg'
import de_flag from '../images/de.svg'
import en_flag from '../images/en.svg'
import t from './translate'
import i18n, { setURL } from './i18n'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'

function LanguageSwitch () {

  let [mouseEnter, setMouseEnter] = useState(false)

  const getLanguageFlag = (lang) => {
    if (lang === 'en') {
      return en_flag
    } else {
      return de_flag
    }
  }

  const changeLanguage = lng => {
    let count = document.querySelectorAll('.button-lang').length
    setURL(lng)
    i18n.changeLanguage(lng)
  }

  return <div className={'language-switch'}
              onMouseEnter={() => {setMouseEnter(true)}}
              onMouseLeave={() => {setMouseEnter(false)}}>
    <div className={'current'}><img src={getLanguageFlag(i18n.language)}/></div>
    {mouseEnter && <div className={'dropdown'}>
      <a onClick={() => changeLanguage('de')}><img src={de_flag}/></a>
      <a onClick={() => changeLanguage('en')}><img src={en_flag}/></a>
    </div>}
  </div>
}

export default function Header ({ homeUrl }) {
  return (<>
      <Container fluid={true} className={'header'}>
        <Row className={'justify-content-between'} style={{'marginLeft': '10px'}}>
          <Col>
            <a href={homeUrl} className="layout__logo ir">
              <img className="" src={logo} alt={t('logoAlt')} width="225"/>
            </a>
          </Col>
          <Col xs={'auto'}>
            <div style={{ 'width': '50px' }}>
              {/* <LanguageSwitch/> */}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}
